var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSecurityCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "secure-payment",
    transform: "translate(-32.499)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48573",
    "data-name": "Path 48573",
    d: "M133.348,131.488a.642.642,0,0,0-.451-.186.634.634,0,0,0-.451.186l-2.234,2.234-.772-.772a.638.638,0,0,0-.9.9l1.223,1.223a.633.633,0,0,0,.451.185h0a.634.634,0,0,0,.451-.185l2.686-2.686A.639.639,0,0,0,133.348,131.488Z",
    transform: "translate(-90.94 -124.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48574",
    "data-name": "Path 48574",
    d: "M47.468,3.709a.327.327,0,0,0-.186-.266L40.144.032a.338.338,0,0,0-.291,0L32.715,3.444a.327.327,0,0,0-.186.266A17.741,17.741,0,0,0,33.1,9.256a14.739,14.739,0,0,0,2.126,4.7,12.455,12.455,0,0,0,4.616,4,.338.338,0,0,0,.306,0,12.455,12.455,0,0,0,4.616-4,14.738,14.738,0,0,0,2.126-4.7A17.742,17.742,0,0,0,47.468,3.709ZM40,12.653A4.2,4.2,0,0,1,35.767,8.5a4.232,4.232,0,0,1,8.464,0A4.2,4.2,0,0,1,40,12.653Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSecurityCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_security_check.90c2e69ae1478d965811ee65066c0cb0.svg";